import { useNavigate } from 'react-router-dom';
import { useCallback, useRef, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getOrders } from '../../api/Order';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { ScanBarcode } from '../../components/Barcode/ScanBarcode';

export const ScanOrderCargoNoPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const lastScanRef = useRef('');

  const goBack = () => navigate('/sales/orders');

  const onScan = useCallback(
    (barcode: string) => {
      if (lastScanRef.current === barcode) return;
      lastScanRef.current = barcode;

      setLoading(true);

      getOrders({
        cargoNo: barcode,
        pagination: { page: 0, pageSize: 1 },
      })
        .then((orders) => {
          if (orders.data.length > 0) {
            navigate(`/sales/orders/${orders.data[0].id}`);
          } else {
            toast.error('Okutulan barkoda ait bir sipariş kaydı bulunamadı.');
          }
        })
        .catch((err) => toast.error(err.message))
        .finally(() => {
          setLoading(false);
        });
    },
    [loading],
  );

  return (
    <Box sx={{ ...sharedStyles.pageBody, gap: 1.5 }}>
      <Waiting open={loading} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          mb: 3,
          gap: 1.5,
        }}
      >
        <IconButton onClick={goBack} sx={{ ...sharedStyles.backIcon }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant='h5'>Sipariş Kargo Çıktısı Tara</Typography>
      </Box>

      <ScanBarcode onScan={onScan} onCancel={goBack} />
    </Box>
  );
};
